
<div *ngIf="visible&&!errorEnabled">
    <div *ngIf="carrierCode=='aromex'" fxLayout="column" fxLayoutGap="10px">
        <p>Delivery Status : {{status?.UpdateDescription}}</p>
        <p>Updated Date : {{status?.UpdateDateTime}}</p>
    </div>
    <div *ngIf="carrierCode=='shipRocket'&&status!=null">
        <div fxLayout="column" fxLayoutGap="10px">
            <p>Delivery Status : {{shippingStatus}}</p>
            <!-- <p>Updated Date : {{updates| date:'medium'}}</p> -->
            <p>Track : <a class="pointer" (click)="trackUrl() ">{{trackingUrl}}</a></p>
        </div>
        <div class="padding-10">
            <div fxLayout="row" fxLayoutAlign="center center">
                <h3>Tracking Information</h3>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div *ngFor="let item of updates" class="order-tracking completed">
                    <span class="is-complete"></span>
                    <span>{{item.activity}}<br><small>{{item.date| date:'medium'}}</small></span>
                </div>
               
            </div>
        </div>


    </div>
</div>

<div *ngIf="carrierCode=='shipRocket'&&errorEnabled">

    {{errorMessage}}


</div>


<div *ngIf="carrierCode=='custom'" fxFlex>

    <calsoft-timeline [value]="trackNumber" style="width: 100%;"></calsoft-timeline>
</div>


